var React = require('react');

function Video (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"2","width":"20","height":"20","rx":"2.18","ry":"2.18","key":0}),React.createElement("line",{"x1":"7","y1":"2","x2":"7","y2":"22","key":1}),React.createElement("line",{"x1":"17","y1":"2","x2":"17","y2":"22","key":2}),React.createElement("line",{"x1":"2","y1":"12","x2":"22","y2":"12","key":3}),React.createElement("line",{"x1":"2","y1":"7","x2":"7","y2":"7","key":4}),React.createElement("line",{"x1":"2","y1":"17","x2":"7","y2":"17","key":5}),React.createElement("line",{"x1":"17","y1":"17","x2":"22","y2":"17","key":6}),React.createElement("line",{"x1":"17","y1":"7","x2":"22","y2":"7","key":7})]);
}

Video.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Video;

Video.default = Video;
